function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
var any = PropTypes.any;
var layoutStyles = {
  height: "100%",
  width: "100%",
  display: "flex",
  flexDirection: "column"
};
var wrapStyles = {
  display: "flex",
  flexGrow: 1,
  overflow: "hidden"
};
var mainStyles = {
  overflow: "auto",
  flexGrow: 1,
  position: "relative"
};
var barStyles = {
  flexGrow: 0,
  flexShrink: 0,
  position: "relative"
};
var panelStyles = {
  flexGrow: 0,
  flexShrink: 0,
  overflowY: "auto",
  position: "relative"
};
var propTypes = {
  header: any,
  headerBorder: any,
  subHeader: any,
  subHeaderBorder: any,
  children: any,
  leftPanel: any,
  leftPanelWidth: any,
  leftPanelBorder: any,
  rightPanel: any,
  rightPanelWidth: any,
  rightPanelBorder: any,
  footer: any,
  footerBorder: any,
  className: any
};
var defaultProps = {
  headerBorder: "1px solid #D2DDE0",
  subHeaderBorder: "1px solid #D2DDE0",
  leftPanelBorder: "1px solid #D2DDE0",
  leftPanelWidth: 300,
  rightPanelBorder: "1px solid #D2DDE0",
  rightPanelWidth: 300,
  footerBorder: "1px solid #D2DDE0"
};

var Layout = function Layout(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("et--layout", props.className),
    style: layoutStyles
  }, props.header && /*#__PURE__*/React.createElement("div", {
    className: "et--layout--header",
    style: _objectSpread(_objectSpread({}, barStyles), {}, {
      borderBottom: props.headerBorder
    })
  }, props.header), props.subHeader && /*#__PURE__*/React.createElement("div", {
    className: "et--layout--sub-header",
    style: _objectSpread(_objectSpread({}, barStyles), {}, {
      borderBottom: props.subHeaderBorder
    })
  }, props.subHeader), /*#__PURE__*/React.createElement("div", {
    className: "et--layout--main-wrap",
    style: wrapStyles
  }, props.leftPanel && /*#__PURE__*/React.createElement("div", {
    className: "et--layout--left-panel",
    style: _objectSpread(_objectSpread({}, panelStyles), {}, {
      width: props.leftPanelWidth,
      borderRight: props.leftPanelBorder
    })
  }, props.leftPanel), /*#__PURE__*/React.createElement("div", {
    className: "et--layout--main",
    style: mainStyles
  }, props.children), props.rightPanel && /*#__PURE__*/React.createElement("div", {
    className: "et--layout--right-panel",
    style: _objectSpread(_objectSpread({}, panelStyles), {}, {
      width: props.rightPanelWidth,
      borderLeft: props.rightPanelBorder
    })
  }, props.rightPanel)), props.footer && /*#__PURE__*/React.createElement("div", {
    className: "et--layout--footer",
    style: _objectSpread(_objectSpread({}, barStyles), {}, {
      borderTop: props.footerBorder
    })
  }, props.footer));
};

Layout.displayName = "Layout";
Layout.propTypes = propTypes;
Layout.defaultProps = defaultProps;
export default Layout;